import { getSpecificRequiredFieldMap } from './errorDictionary';
import { isNotEmpty } from '../../utils/fieldValidators';
import useValidators from './useValidators';
function useRequiredField(fieldNameMap) {
    const validators = [isNotEmpty];
    return useValidators([getSpecificRequiredFieldMap(fieldNameMap)], validators);
}
export default useRequiredField;
